import { render, staticRenderFns } from "./SimpleGroupCard.vue?vue&type=template&id=079bc514&"
import script from "./SimpleGroupCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleGroupCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VImg,VListItem})
